export default "__VITE_ASSET__VHxwD$Px__"